import React, { useState, useEffect } from 'react';
import clsx from 'clsx';
import './Inventories.css'
import NotFound from '../../../Images/notFound.png';
import { Paper, makeStyles, TableBody, TableRow, TableCell, CircularProgress, Divider } from '@material-ui/core';
import useTable from '../../useTable';
import SearchIcon from '@material-ui/icons/Search';
import CheckUserProvider from '../../../AllHooks/CheckUserProvider';
import CustomAlert from '../../CustomAlert';
import { Helmet } from 'react-helmet';
import { getSalesBillsDocumentWithUserId } from '../../../Backend/firebase/sales-bills';
import InventoriesFilter from './InventoriesFilter';
import { getProductStockDocumentWithUserId } from '../../../Backend/firebase/product-stock';


const useStyles = makeStyles((theme) => ({
    paper: {
        padding: theme.spacing(2),
        display: 'flex',
        overflow: 'initial',
        flexDirection: 'column',
    },
    fixedHeight: {
        height: '100%',
    },
}));

const headCells = [
    { id: 'ProductName', label: 'Product Info', disableSorting: true }
]

function InventoriesHistory() {
    const classes = useStyles();
    const fixedHeightPaper = clsx(classes.paper, classes.fixedHeight);
    const { userData } = CheckUserProvider();
    const [records, setRecords] = useState([]);
    const [filterFn, setFilterFn] = useState({ fn: items => { return items; } });
    const [searchChange, setSearchChange] = useState(false);
    const [pageAfterSearch, setPageAfterSearch] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } = useTable(records, headCells, filterFn,
        searchChange, pageAfterSearch);
    const [openNotify, setOpenNotify] = useState(false);
    const [notificationMessage, setNotificationMessage] = useState('');
    const [alertType, setAlertType] = useState('');

    const handleSearch = (e) => {
        let target = e.target;
        if (target.value === '') {
            setSearchChange(false);
            setPageAfterSearch(false);
        }
        else {
            setSearchChange(true);
            setPageAfterSearch(true);
        }
        setFilterFn({
            fn: items => {
                if (target.value === "") {
                    return items
                } else {
                    return items.filter(x => x.PartyName.toLowerCase().includes(target.value.toLowerCase()));
                }
            }
        });
    };

    useEffect(async () => {
        if (userData) {
            setIsLoading(true);
            try {
                const getProductStocks = await getProductStockDocumentWithUserId(userData.uid);
                setRecords(getProductStocks);
                setIsLoading(false);
            } catch(error) {
                console.log("Error Occur in Get Product", error)
                setIsLoading(false);
            }
        }
    }, [userData]);

    const handleFilters = async (filter) => {
        console.log('Filter Changed => ', filter);
    };

    const refreshData = async () => {
        if (userData) {
            setIsLoading(true);
            try {
                const getProductStocks = await getProductStockDocumentWithUserId(userData.uid);
                setRecords(getProductStocks);
                setIsLoading(false);
                setNotificationMessage('Sales Product updated successfully.');
                setOpenNotify(true);
                setAlertType('success');
            } catch(error) {
                console.log("Error Occur in Get Product", error)
                setIsLoading(false);
            }
        }
    };

    return (
        <>
            {!userData || isLoading ?
                (<div className="row">
                    <div className="col-md-12 text-center p-4">
                        <CircularProgress />
                    </div>
                </div>) :
                (<div className="allProductsAndSales">
                    <Paper className={fixedHeightPaper}>
                        <Helmet>
                            <meta name="description" content="Find Product you have posted till now." />
                            <title>Product | Kaipsool Pharmatech</title>
                        </Helmet>
                        <div className="row d-flex justify-content-center align-items-center">
                            <div className="col-md-8">
                                <InventoriesFilter handleFilters={handleFilters} refreshData={refreshData} />
                            </div>
                            <div className="col-md-4">
                                <div className="d-flex justify-content-center w-100 align-items-center allProductsTable__searchBox">
                                    <SearchIcon className="mr-2" />
                                    <input type="text" placeholder="Search Product..." className="border-0"
                                        onChange={handleSearch} />
                                </div>
                            </div>
                            {records.length > 0 ? <div className="row col-md-12">
                                <h5 className="mt-3 border__bottom">Available Stocks</h5>
                                {
                                    recordsAfterPagingAndSorting().map(item => (
                                        <> 
                                            <div className="col-lg-3 col-md-3 col-sm-12 topSkills topSkills__productDisplay" key={item.id}>
                                                <div className="card-events card-products all-products">
                                                    <div className="card-events-body d-flex flex-column white__background__color position__class">
                                                        <div className="card-inventories-details">
                                                            <h5 className="card-events-title black__color product__mainTitle">{item?.ProductEntry[0]?.ProductName ? item?.ProductEntry[0]?.ProductName : "NA"}</h5>
                                                            <p className="card-events-title black__color">{item?.ProductEntry[0]?.PackagingType ? item?.ProductEntry[0]?.PackagingType : "NA"}</p>
                                                            <p className="card-events-title black__color">Total Stock : <b>{item?.TotalStock ? item?.TotalStock : "NA"}</b></p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </>
                                    ))
                                }
                                <TblPagination />
                            </div> : <div className="row col-md-12 mt-3 text-center">
                                <img src={NotFound} className="notFound" />
                                <h4>No Product Record Found!</h4>
                            </div>}
                        </div>
                    </Paper>
                </div>)
            }
            <CustomAlert setOpenNotify={setOpenNotify} openNotify={openNotify} messageType={alertType || 'error'}
                notificationMessage={notificationMessage} />
        </>
    )
}

export default InventoriesHistory
